export const formControlStyle = {
  backgroundColor: "#ffffff",
  border: "1.5px solid #b783cc",
  borderRadius: "5px",
  paddingTop: "0px",
  fontFamily: "'Archivo',sans-serif",
  "& .MuiInputBase-input": {
    fontFamily: "'Archivo',sans-serif",
  },
};

export const inputLableStyle = {
  fontSize: "13px",
  lineHeight: "20px",
  color: "#1f1f1f",
  fontWeight: 600,
  fontFamily: "'Archivo',sans-serif",
};

export const outlineInputStyle = {
  fontFamily: "'Archivo',sans-serif",
  color: "#1f1f1f",
};

export const radioLabelStyle = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  fontFamily: "'Archivo',sans-serif",
};

export const resultLabelStyle = {
  fontSize: 13,
  lineHeight: "20px",
  fontWeight: 600,
  color: "#1f1f1f",
  fontFamily: "'Archivo',sans-serif",
  textAlign: "start",
};

export const resultOutputStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: {
    xs: "20px",
    sm: "24px",
    md: "24px",
  },
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  fontWeight: 700,
  color: "#005FB9",
};

export const paragraphStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.08px",
  textAlign: "start",
};
export const paragraphStyleOL = {
  listStyle: "number",
  fontFamily: "'Archivo', sans-serif",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.08px",
  textAlign: "start",
};
export const paragraphStyleUL = {
  listStyle: "disc",
  fontFamily: "'Archivo', sans-serif",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.08px",
  textAlign: "start",
};

export const headingStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "24px",
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  color: "#1F1F1F",
};

export const MLTLinks = {
  width: "max-content",
  fontSize: "11.5px",
  lineHeight: "16.9354px",
  letterSpacing: "0.64px",
  fontFamily: "'Archivo',sans-serif",
  backgroundColor: "#D6D6D6",
  textTransform: "none",
};

export const MoreLikeThisBigButton = {
  backgroundColor: "#f4ecf9",
  "&:hover": {
    backgroundColor: "#e0d1ef",
  },
};
export const MoreLikeThisSmallButton = {
  backgroundColor: "#f4ecf9",
  "&:hover": {
    backgroundColor: "#e0d1ef",
  },
  textAlign: "start",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

export const MLTLoginButton = {
  fontSize: 16,
  lineHeight: "24px",
  textAlign: "center",
  fontFamily: "'Archivo',sans-serif",
  textDecoration: "none",
  padding: "15px 15px",
  border: "none",
  color: "#fff",
  backgroundColor: "#7E40AD",
  "&:hover": {
    backgroundColor: "#693694",
  },
};

export const CollaboratorFactChecked = {
  fontSize: "12px",
  color: "#005FB9",
};
